export default {
  current_form: 'login'
}